import React, { useContext } from 'react'
import { useParams } from "react-router-dom";
import { LassieContext } from '../../context/LassieProvider';
import { lightningUserActionAPI } from "../../api";
import { formatInspectionDateToYMD } from '../../prettyDate';
import markedForInspIcon from '../../assets/img/mark-for-inspection-color.png'
import handledIcon from "../../assets/img/handled-icon-color.png";
import deleteIcon from "../../assets/img/delete-icon.png";
import deleteIconColor from "../../assets/img/delete-icon-color.png";
import './user-actions-overview.css'

export default function UserActionsOverview({ historicUserActions, turbine, downloadAttachment, documentLoading, fetchUserActions, setTurbinePopup, fetchInspections }) {
    const { fetchTurbines } =
        useContext(LassieContext);

    let { turbine_id } = useParams();
    turbine_id = parseInt(turbine_id);


    const handleDeleteAction = async (id) => {
        try {
            const res = await lightningUserActionAPI.delete_user_action(id)
            if (res === 'OK') {
                fetchUserActions();
                fetchTurbines(null, turbine_id);
                fetchInspections(turbine_id);
            }
        } catch (error) {
            console.log("There was an error deleting the action: " + error);
            setTurbinePopup({
                show: true,
                status: 'wrong',
                title: 'Something went wrong',
                buttonText: 'Close',
                buttonStatus: 'wrong',
                text: error.response?.data
            });
        } finally {
        }
    }

    const getIcon = (turbine) => {
        let action = turbine.action
        if (!action) return null;

        if (action.marked_for_repair) {
            return markedForInspIcon
        }
        if (action === "marked_for_inspection" || action === "inspection" || action === 'marked_for_repair') {
            return markedForInspIcon;
        } else if (action === "acceptable_risk") {
            return handledIcon;
        } else {
            return null;
        }
    };

    const formatAction = (action) => {
        const formatted = action.replace(/_/g, " ");
        return formatted.charAt(0).toUpperCase() + formatted.slice(1);
    };

    return (
        <div className='user-action-overview-container'>
            <h2>Action history</h2>
            <table className="user-action-table">
                <thead className='user-action-table-header'>
                    <tr>
                        <th>{" "}</th>
                        <th>Action</th>
                        <th>Target date</th>
                        <th>Timestamp created</th>
                        <th>Username</th>
                        <th>Comment</th>
                        <th>Attachment</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {[...historicUserActions]
                        .sort((a, b) => new Date(b.timestamp_created) - new Date(a.timestamp_created))
                        .map((action) => (
                            <tr key={action.id}>
                                <td>
                                    {action && (
                                        <img
                                            src={getIcon(action)}
                                            className="action-icon"
                                            alt="Action icon"
                                        />
                                    )}
                                </td>
                                <td>{formatAction(action.action)}</td>
                                <td>{formatInspectionDateToYMD(action?.target_date)}</td>
                                <td>{action.timestamp_created}</td>
                                <td>{action.user_name}</td>
                                <td
                                    className={`comment-wrapper ${action.user_comment} ? "action_comment" : ""`}
                                    data-full-comment={action.user_comment || undefined}
                                >
                                    {action.user_comment}
                                </td>
                                <td onClick={
                                    action.document_id
                                        ? () => downloadAttachment(action.document_id)
                                        : undefined
                                }
                                    className={
                                        action.document_name
                                            ? `downloadable-attachment${documentLoading.id === action.document_id && documentLoading.status
                                                ? " document-loading"
                                                : ""
                                            }`
                                            : ""
                                    }
                                >
                                    {action.document_name}
                                </td>


                                {turbine.latest_user_action &&
                                    turbine.latest_user_action.id === action.id ? (
                                    <td>
                                        <button
                                            className="delete-btn"
                                            onClick={() => {
                                                setTurbinePopup({
                                                    show: true,
                                                    status: 'warning',
                                                    title: 'Delete action',
                                                    buttonText: 'Cancel',
                                                    buttonStatus: 'success',
                                                    action: () => {
                                                        setTurbinePopup({ show: false });
                                                    },
                                                    buttonText2: 'Delete',
                                                    buttonStatus2: 'wrong',
                                                    action2: () => {
                                                        handleDeleteAction(action.id);
                                                        setTurbinePopup({ show: false });
                                                    },
                                                    text: 'Are you sure you want to delete this user action?',
                                                })
                                            }}
                                        >
                                            Delete{" "}
                                            <img
                                                src={deleteIconColor}
                                                alt="Delete user action"
                                                className="action-icon default-icon"
                                            />
                                            <img
                                                src={deleteIcon}
                                                alt="Delete user action"
                                                className="action-icon hover-icon"
                                            />
                                        </button>
                                    </td>
                                ) : (
                                    <td></td>
                                )}
                            </tr>
                        ))}
                    {historicUserActions.length === 0 && (
                        <tr>
                            <td colSpan={6}>
                                No registered user actions for this turbine.
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    )
}

